// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"461":"a2b32724","787":"c565ce82","853":"4ec7bd6e","892":"9d8946dd"}[chunkId] + ".chunk.js";
};